import { Button, Grid, TextField, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { TOKEN_KEY, url } from 'src/Helpers/utils/Constant';
import Toaster from 'src/Toaster/Toaster';

export default function CreateHeroImage({ handleClose, setRefreshTrigger }) {
  const { register, handleSubmit, reset } = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const theme = useTheme();
  const Toast = Toaster();
  const token = localStorage.getItem(TOKEN_KEY);

  const onSubmit = async (values) => {
    console.log({ values });
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('order', values.order);
      formData.append('image', values.image[0]);
      formData.append('alt_text', values.alt_text || '');
      const { data } = await axios.post(
        `${url}/api/v1/admin/website-slider`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log(data);
      if (data.success) {
        Toast.fire({
          icon: 'success',
          title: `${data.message}`,
        });
        setRefreshTrigger((prev: number) => prev + 1);
        setLoading(false);
        handleClose();
      } else {
        Toast.fire({
          icon: 'fail',
          title: `${data.message}`,
        });
        setLoading(false);
      }
    } catch (err: any) {
      Toast.fire({
        icon: 'error',
        title: `${err.response?.data?.message}`,
      });
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        onSubmit={handleSubmit(onSubmit)}
        component='form'
        sx={{ p: 2, mt: 1 }}
      >
        <Grid container spacing={2}>
          <Grid xs={12} sm={12} item lg={6}>
            <TextField
              margin='normal'
              fullWidth
              required
              id='name'
              label='Type an order'
              {...register('order')}
              type='number'
              autoFocus
              inputProps={{ step: 1, min: 1 }}
              variant='outlined'
            />
          </Grid>

          <Grid xs={12} sm={12} lg={6} item>
            <TextField
              margin='normal'
              fullWidth
              id='alt_text'
              label='Alt text'
              {...register('alt_text')}
              type='text'
              variant='outlined'
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <TextField
              margin='normal'
              fullWidth
              id='image'
              label='Upload image'
              inputProps={{
                accept: 'image/png, image/jpeg, image/jpg, image/webp',
              }}
              InputLabelProps={{ shrink: true }}
              autoComplete='image'
              type='file'
              {...register('image')}
              autoFocus
            />
          </Grid>
        </Grid>
        <Typography
          sx={{
            backgroundColor: theme.colors.warning.lighter,
            padding: 1,
            borderRadius: 1,
          }}
        >
          <Typography
            sx={{ fontWeight: 700, color: theme.colors.warning.main }}
          >
            {' '}
            Image Upload Tips:
          </Typography>{' '}
          <Typography>
            Select your images in the order you want them to appear — first
            selected = first shown.
          </Typography>
        </Typography>
        {loading ? (
          <Button
            disabled
            fullWidth
            variant='contained'
            disableElevation
            sx={{
              mt: 3,
              mb: 2,
              py: 1,
            }}
          >
            loading...
          </Button>
        ) : (
          <Button
            type='submit'
            fullWidth
            variant='contained'
            disableElevation
            sx={{
              mt: 3,
              mb: 2,
              py: 1,
            }}
          >
            Create Hero Image
          </Button>
        )}
      </Box>
    </>
  );
}
